/*
  c: category, 区分
  d: datetime,
  g: group, 分類
  m: money
  s: status,
  t: type, 種別
  a: attribute, その他の属性
 */

/* // node はコメントを外す
import * as hf from './_hf';
import * as ht from './_ht';
import { _00z } from './_hd_00';
import { _10z } from './_hd_10';
import { _20z } from './_hd_20';
import { _30z } from './_hd_30';
import { _31z } from './_hd_31';
import { _40z } from './_hd_40';
import { _41z } from './_hd_41';
import { _42z } from './_hd_42';
import { _50z } from './_hd_50';
import { _51z } from './_hd_51';
import { _60z } from './_hd_60';
import { _61z } from './_hd_61';
import { _70z } from './_hd_70';
import { _80z } from './_hd_80';
import { _a0z } from './_hd_a0';
//*/

//*// node はコメント
/*
import {
  hf,
  ht,
  _00z,
  _10z,
  _20z,
  _30z,
  _31z,
  _40z,
  _41z,
  _42z,
  _50z,
  _51z,
  _60z,
  _61z,
  _70z,
  _80z,
  _a0z,
} from 'lib';
*/
//*/

import * as hf from "./_hf";
import * as ht from "./_ht";

import { _00z } from "./_hd_00";
import { _10z } from "./_hd_10";
import { _20z } from "./_hd_20"; // ドメイン
import { _30z } from "./_hd_30"; // 法人
import { _31z } from "./_hd_31"; // 部門
import { _40z } from "./_hd_40";
import { _41z } from "./_hd_41";
import { _42z } from "./_hd_42";
import { _50z } from "./_hd_50";
import { _51z } from "./_hd_51";
import { _60z } from "./_hd_60"; // 祝日
import { _61z } from "./_hd_61"; // 休日
import { _70z } from "./_hd_70"; // メール
import { _80z } from "./_hd_80"; // stripe
import { _a0z } from "./_hd_a0"; // 処理対象

import { i10z } from './ihdI10'; // 部屋
import { i11z } from './ihdI11'; // 時間帯区分
import { i15z } from './ihdI15'; // 団体種別
import { i16z } from './ihdI16';
import { i17z } from './ihdI17'; // 備品・駐車場
import { i18z } from './ihdI18'; // 団体
import { i19z } from './ihdI19'; // クライアント
import { i20z } from './ihdI20'; // メールサーバ（ドメイン共通）
import { i1zz } from './ihdI1z'; // 予約
import { i1yz } from './ihdI1y'; // 抽選

let $ihdz = {} as ht.dz;

export const grtIhdz = () => {
  if (hf.f($ihdz)) {
    return $ihdz;
  }
  else {
    $ihdz = {
      ..._00z,
      ..._10z,
      ..._20z,
      ..._30z,
      ..._31z,
      ..._40z,
      ..._41z,
      ..._42z,
      ..._50z,
      ..._51z,
      ..._60z,
      ..._61z,
      ..._70z,
      ..._80z,
      ..._a0z,
      ...i10z,
      ...i11z,
      ...i15z,
      ...i16z,
      ...i17z,
      ...i18z,
      ...i19z,
      ...i20z,
      ...i1yz,
      ...i1zz,
    };
    return $ihdz;
  }
}

/*
export const $ihdz = ({
  ... _00z,
  ... _10z,
  ... _20z,
  ... _30z,
  ... _31z,
  ... _40z,
  ... _41z,
  ... _42z,
  ... _50z,
  ... _51z,
  ... _60z,
  ... _61z,
  ... _70z,
  ... _80z,
  ... i10z,
  ... i11z,
  ... i15z,
  ... i16z,
  ... i17z,
  ... i18z,
  ... i19z,
  ... i1yz,
  ... i1zz
} as ht.dz);
*/
export const i = (
  pElm: ht.s,
  pVsn?: ht.s | null,
) => {
  const _ihdz = grtIhdz();
  const _elm = pElm;
  const _vsn = pVsn ?? 'v0';
  //  return hf.copyDz(_ihdz[_elm]?.[_vsn].itlz); // deep copy
  return hf.copyDz(_ihdz[_elm][_vsn].itlz); // deep copy
};

export const f = (
  pFld: ht.s,
  pElm?: ht.s,
  pVsn?: ht.s | null,
) => {
  const _ihdz = grtIhdz();
  const _elm = pElm ? pElm : String(pFld).substring(0, 4);
  const _vsn = pVsn ?? 'v0';
  //hf.l(`ihd 133: ${hf.s($ihdz)}`);
  //hf.l(`ihd 134: ${_elm}, ${_vsn}`);
  //hf.l(`ihd 135: ${hf.s($ihdz[_elm])}`);
  //  return _ihdz[_elm]?.[_vsn]?.fldz[pFld];
  return _ihdz[_elm][_vsn].fldz[pFld];
};

export const r = (
  pLs: ht.ls,
  pVle: ht.a,
) => {
  return (pVle || pVle == 0) ? hf.getDz(pLs, pVle, 'key')?.pfx : null
};

export const nd = (ls: ht.ls) => {
  return ls ? ls.filter((_dz: ht.dz) => hf.f(_dz) && _dz._dlt != 1) : [];
}; // no delete